// extracted by mini-css-extract-plugin
export var mainWrapper = "VCFooter-module--mainWrapper--DZIAx";